import { restClient } from '@/Core/Services/RestClientService'
import { GetRestUrlByResourceTask } from '@/Core/Tasks/Resources/GetRestUrlByResourceTask'

/** Фото, яке повертає POST /services/user/photo_files (IRI йде в user.photo) */
export interface UserPhotoFile {
    '@id': string
    url: string
    [key: string]: unknown
}

/** POST /services/user/photo_files — завантажити файл фото (multipart) */
export const UploadUserPhotoTask = async (file: Blob, name: string): Promise<UserPhotoFile> => {
    const body = new FormData()
    body.append('file', file, name)
    body.append('name', name)

    const request = restClient.post('/services/user/photo_files', { body }, { isNotHeaderAddContentType: true } as any)
    if (!request) throw new Error('restClient.post returned null')
    return (await request) as unknown as UserPhotoFile
}

/** PATCH /services/users/{uuid} з { photo: IRI | null } — поставити або прибрати фото */
export const SaveUserPhotoTask = async (userUuid: string, photoIri: string | null): Promise<Record<string, any>> => {
    const url = GetRestUrlByResourceTask('Setting.User', 'patch', { id: userUuid })
    if (!url) throw new Error('Setting.User resource URL not resolved')
    const request = restClient.patch(url, { json: { photo: photoIri } })
    if (!request) throw new Error('restClient.patch returned null')
    return (await request) as unknown as Record<string, any>
}
